import { fromJS, is } from 'immutable';
export const TRUSTED_ORIGIN_REGEX = /^https:\/\/(local|app)(-[^.]+)?.hubspot(qa)?.com/;
export const getLowerCased = maybeMap => {
  if (!maybeMap) {
    return maybeMap;
  }
  if (typeof maybeMap.map !== 'function') {
    return typeof maybeMap.toLowerCase === 'function' ? maybeMap.toLowerCase() : maybeMap;
  }
  return maybeMap.map(item => item && typeof item.toLowerCase === 'function' ? item.toLowerCase() : item);
};
export const compareIgnoringStringCaseAsImmutables = (a, b) => {
  const immutableA = a && typeof a.toJS === 'undefined' ? fromJS(a) : a;
  const immutableB = b && typeof b.toJS === 'undefined' ? fromJS(b) : b;
  return is(getLowerCased(immutableA), getLowerCased(immutableB));
};
export const windowReload = () => window.location.reload();
export const getHref = () => window.location.href;
export const redirectTo = url => {
  window.location.href = url;
};
export const openLinkInNewTab = url => {
  window.open(url, '_blank');
};
export const isImmutable = value => value && typeof value.asImmutable === 'function';
export const encodeHTMLTagsOutsideHubl = (text = '') => {
  const regexLt = new RegExp(/<(?![^{{]*\}\})/g);
  const regexGt = new RegExp(/>(?![^{{]*\}\})/g);
  return text.replace(regexLt, '&lt;').replace(regexGt, '&gt;');
};
export const decodeHTMLTagsOutsideHubl = (text = '') => {
  const regexLt = new RegExp(/&lt;(?![^{{]*\}\})/g);
  const regexGt = new RegExp(/&gt;(?![^{{]*\}\})/g);
  return text.replace(regexLt, '<').replace(regexGt, '>');
};
export function prefixKeys(prefix, obj, separator = '_') {
  return Object.entries(obj).reduce((result, [key, value]) => {
    result[`${prefix}${separator}${key}`] = value;
    return result;
  }, {});
}